import { Link } from "react-router-dom";
import { formatUsdcBaseUnits } from "@hybrid-escrow/shared";
import { useAuthPrincipal } from "../hooks/useAuthPrincipal";
import { useWalletBalances } from "../hooks/useWalletBalances";
import { shortAddress } from "../lib/format";

export function HeaderWallet() {
  const { isInitialized, isSignedIn, smartAccountAddress, principal, signOut } = useAuthPrincipal();
  const { data: balances } = useWalletBalances(smartAccountAddress);

  if (!isInitialized) {
    return <span className="text-sm muted">Loading wallet…</span>;
  }

  if (!isSignedIn) {
    return (
      <Link to="/sign-in" className="btn btn-primary btn-sm">
        Sign in
      </Link>
    );
  }

  return (
    <div className="row" style={{ gap: "12px" }}>
      <Link
        to="/wallet"
        className="row"
        style={{ textDecoration: "none", color: "inherit", gap: "10px" }}
      >
        {balances && (
          <span className="badge badge--info" aria-label="USDC balance">
            ${formatUsdcBaseUnits(balances.usdcBaseUnits)}
          </span>
        )}
        <span className="mono text-sm">
          {smartAccountAddress ? shortAddress(smartAccountAddress) : "No wallet yet"}
        </span>
        {principal?.role && principal.role !== "USER" && (
          <span className="badge badge--warning">{principal.role}</span>
        )}
      </Link>
      <button type="button" className="btn btn-secondary btn-sm" onClick={() => void signOut()}>
        Sign out
      </button>
    </div>
  );
}
